import React, { memo } from 'react';
import { getGenderAvatarBg } from '../../utils/genderColors';
import { getInitials } from '../../utils/nameUtils';
import { getPlayerFullName } from '../../utils/playerUtils';
import { getPlayerAvatarPublicUrl } from '../../services/avatarService';

const SIZE_CLASSES = {
  sm: 'h-6 w-6 text-[10px]',
  md: 'h-8 w-8 text-xs',
  lg: 'h-10 w-10 text-sm',
  xl: 'h-12 w-12 text-base',
};

/**
 * Circular player avatar with gender-colored fallback initials.
 */
function PlayerAvatar({ player, size = 'md', className = '', title }) {
  if (!player) return null;

  const displayName = getPlayerFullName(player);
  const sizeClass = SIZE_CLASSES[size] || SIZE_CLASSES.md;
  const tooltip = title ?? displayName;

  return (
    <div
      className={`flex shrink-0 items-center justify-center overflow-hidden rounded-full ${getGenderAvatarBg(player.gender)} ${sizeClass} ${className}`}
      title={tooltip}
    >
      {player.avatar_url ? (
        <img
          src={getPlayerAvatarPublicUrl(player.avatar_url, false)}
          alt={displayName}
          className="h-full w-full object-cover"
          loading="lazy"
        />
      ) : (
        <span className="font-semibold text-white">{getInitials(displayName)}</span>
      )}
    </div>
  );
}

export default memo(PlayerAvatar);
